var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          staticClass: "dialog",
          attrs: {
            title: _vm.title,
            visible: _vm.dialogVisible,
            "close-on-click-modal": false,
            "close-on-press-escape": false,
            width: "50%",
            center: "",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
            close: _vm.onHandleClose,
          },
        },
        [
          _vm.dataobj
            ? _c("div", { staticClass: "reviewDialogrefcss" }, [
                _c(
                  "div",
                  {
                    staticStyle: {
                      display: "flex",
                      "align-items": "center",
                      "margin-bottom": "20px",
                    },
                  },
                  [
                    _c("div", { staticStyle: { flex: "1" } }, [
                      _vm._v(" 装卸队：" + _vm._s(_vm.dataobj.fleetName) + " "),
                    ]),
                    _c("div", { staticStyle: { flex: "1" } }, [
                      _vm._v("当前余额：" + _vm._s(_vm.dataobj.availAmount)),
                    ]),
                    _c("div", { staticStyle: { flex: "1" } }, [
                      _vm._v("动账调整金额：" + _vm._s(_vm.dataobj.amount)),
                    ]),
                  ]
                ),
                _c("div", { staticStyle: { "margin-bottom": "20px" } }, [
                  _vm._v(" 类目：" + _vm._s(_vm.dataobj.flowTypeName) + " "),
                ]),
                _c("div", { staticStyle: { "margin-bottom": "20px" } }, [
                  _vm._v(
                    " 转账时间：" + _vm._s(_vm.dataobj.transferTime) + " "
                  ),
                ]),
                _c(
                  "div",
                  { staticStyle: { "margin-bottom": "20px" } },
                  [
                    _vm._v(" 转账记录： "),
                    _vm._l(
                      _vm.dataobj.transferImg.split(","),
                      function (item, index) {
                        return _c("el-image", {
                          key: index,
                          staticStyle: { width: "50px", height: "50px" },
                          attrs: { src: item, "preview-src-list": [item] },
                        })
                      }
                    ),
                  ],
                  2
                ),
                _c("div", [_vm._v("备注：" + _vm._s(_vm.dataobj.remark))]),
              ])
            : _vm._e(),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c("el-button", { on: { click: _vm.onHandleClose } }, [
                _vm._v("取 消"),
              ]),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.onHandleSubmit },
                },
                [_vm._v("确认")]
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }